export default __webpack_public_path__ + "static/media/cyl_example_chistach.8302e0ea.png";